"use strict";
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable functional/immutable-data */
/* eslint-disable functional/no-expression-statement */
/* eslint-disable functional/no-conditional-statement */
/* eslint-disable functional/no-return-void */
/* eslint-disable functional/functional-parameters */
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableAutoScrollRestoration = void 0;
/**
 * Sets `window.history.scrollRestoration` to `manual` and returns a
 * function that will restore it to its previous value.
 */
var disableAutoScrollRestoration = function () {
    // https://developer.mozilla.org/en-US/docs/Web/API/History#Browser_compatibility
    if ("scrollRestoration" in window.history) {
        var original_1 = window.history.scrollRestoration;
        window.history.scrollRestoration = "manual";
        return function () { return (window.history.scrollRestoration = original_1); };
    }
    else {
        return function () { };
    }
};
exports.disableAutoScrollRestoration = disableAutoScrollRestoration;
